// Règles QSE affichées en direct dans les formulaires (copie de backend/src/lib/qse.ts).
// Le serveur recalcule toujours la conformité : ceci sert seulement à prévenir l'employé tout de suite.

export interface QseSettingsView { seuilFrais: number; seuilSurgele: number; ecartMaxSonde: number; fournisseurs: string[] }

export const QSE_DEFAULTS_VIEW: QseSettingsView = { seuilFrais: 4, seuilSurgele: -15, ecartMaxSonde: 2, fournisseurs: ['Centrale U'] }

/** Nombre saisi au téléphone : accepte la virgule et le signe moins */
export function parseTemp(v: string): number | null {
  const s = v.trim().replace(',', '.')
  if (s === '' || s === '-') return null
  const n = Number(s)
  return Number.isFinite(n) ? n : null
}

export function checkTemperature(unit: { tMax: number; tMin?: number | null }, ecran: number | null, sonde: number | null, ecartMax: number, degivrage = false) {
  const raisons: string[] = []
  if (degivrage) {
    if (sonde == null) return { conforme: false, raisons: [] as string[], vide: true }
    ecran = null
  }
  const mesure = sonde ?? ecran
  if (mesure == null) return { conforme: false, raisons: [] as string[], vide: true }
  if (mesure > unit.tMax) raisons.push(`trop chaud (max ${unit.tMax} °C)`)
  if (unit.tMin != null && mesure < unit.tMin) raisons.push(`trop froid (min ${unit.tMin} °C)`)
  if (ecran != null && sonde != null && Math.abs(ecran - sonde) > ecartMax) {
    raisons.push(`écran et sonde trop différents (${Math.abs(ecran - sonde).toFixed(1)} °C, max ${ecartMax} °C)`)
  }
  return { conforme: raisons.length === 0, raisons, vide: false }
}

export function checkReception(r: { typeProduits: string; tCamion: number | null; tColis: number | null; dlcOk: boolean; emballageOk: boolean; camionPropre: boolean }, s: QseSettingsView) {
  const raisons: string[] = []
  const seuil = r.typeProduits === 'surgele' ? s.seuilSurgele : r.typeProduits === 'sec' ? null : s.seuilFrais
  if (seuil != null) {
    if (r.tColis == null) raisons.push('température du colis à saisir')
    else if (r.tColis > seuil) raisons.push(`colis trop chaud (max ${seuil} °C)`)
    if (r.tCamion != null && r.tCamion > seuil) raisons.push(`camion trop chaud (max ${seuil} °C)`)
  }
  if (!r.dlcOk) raisons.push('dates trop courtes')
  if (!r.emballageOk) raisons.push('emballages abîmés')
  if (!r.camionPropre) raisons.push('camion sale')
  return { conforme: raisons.length === 0, raisons }
}

export const COLD_TYPES: { value: string; label: string }[] = [
  { value: 'positif', label: 'Frigo / vitrine (froid positif)' },
  { value: 'negatif', label: 'Congélateur / bac surgelés' },
  { value: 'fl', label: 'Meuble fruits & légumes' },
  { value: 'chambre_pos', label: 'Chambre froide positive' },
  { value: 'chambre_neg', label: 'Chambre froide négative' },
]

export const PRODUCT_TYPES: { value: string; label: string }[] = [
  { value: 'frais', label: 'Frais' },
  { value: 'surgele', label: 'Surgelé' },
  { value: 'mixte', label: 'Frais + surgelé' },
  { value: 'sec', label: 'Sec (pas de température)' },
]

export const DECISIONS: { value: string; label: string }[] = [
  { value: 'accepte', label: 'Acceptée' },
  { value: 'reserve', label: 'Sous réserve' },
  { value: 'refuse', label: 'Refusée' },
]

export const frDate = (iso?: string | null) => (iso ? iso.slice(0, 10).split('-').reverse().join('/') : '—')
